<section id="destinations" class="w-full pb-15 bg-white border-b-2"
    [ngClass]="(view.site?.id === 74 || view.site?.id === 96) ? 'border-[#1B6B4E]':'border-primary-500'">
    <!-- Header -->

    <!-- <div class="h-[600px]">
        <app-banner_section-type01 [options]="{ title: '', imageHref: view.bannerImage }"></app-banner_section-type01>
    </div> -->

    @if (view.page && (view.site?.id === 74 || view.site?.id === 96)) {
    <div class="relative aspect-[16/5] overflow-hidden border-b-2 px-10"
        [ngClass]="(view.site?.id === 74 || view.site?.id === 96) ? 'border-[#1B6B4E]':'border-primary-500'">
        <div class="">
            <img [src]="view.imageLayer1" alt="banner image"
                class="absolute inset-0 h-full object-contain object-center" />
        </div>
    </div>
    }

    @if (view.page && view.site?.id === 79) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[600px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />

        <!-- Flowing wave SVG cut -->
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
            <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
        </svg>
    </div>
    }
    <!-- Loading State -->
    @if (view.isLoading) {
    <div class="flex justify-center items-center mt-20 space-x-1 text-[#1B6B4E] font-accent tracking-widest text-4xl">
        <span class="animate-bounce-0">L</span>
        <span class="animate-bounce-1">o</span>
        <span class="animate-bounce-2">a</span>
        <span class="animate-bounce-3">d</span>
        <span class="animate-bounce-4">i</span>
        <span class="animate-bounce-5">n</span>
        <span class="animate-bounce-6">g</span>
    </div>
    }

    @if (!view.isLoading) {
    <div class="mt-5 flex items-center justify-between px-5 md:px-15">
        <div class="flex flex-col">
            <div class="flex justify-between items-center">
                <div class="flex flex-row my-3">
                    <img class="w-100" src="/assets/images/logo/Optima-Rail-Logo.png?v=2" alt="Optima-Rail-Logo">
                    <!-- <h1 class="text-4xl text-center mb-5 text-[#1B6B4E] font-accent tracking-wider">
                            {{this.view.page.content.name}}
                        </h1> -->
                </div>
                <div class="space-y-2">
                    <p class="text-xl text-[#1B6B4E] font-accent">Beyond the Tracks</p>
                    <p class="text-xl text-[#1B6B4E] font-accent">Beyond the Ordinary</p>
                </div>
            </div>
            <div class="bg-green-800 text-white mb-3 rounded-lg">
                <p class="text-center font-accent md:text-lg py-3 px-2"
                    [innerHTML]="this.view.page.content?.rawContentShort"></p>
            </div>
            <div class="w-full flex flex-col">
                <div class="flex justify-center items-center gap-3">
                    <h1 class="text-2xl text-center font-semibold tracking-wider">Our Services</h1>
                    <img src="/assets/images/logo/railroad-track-icon.png?v=2" class="w-10 md:w-22" alt="">
                </div>
                <div>
                    <p class="text-center font-accent md:text-lg my-3" [innerHTML]="this.view.page.content?.rawContent">
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Europe Rail Services Section -->
    <section class="bg-white p-6 rounded-lg shadow-sm">

        <!-- Rail Sections -->
        <div *ngFor="let region of optimaRail" class="mb-5">

            <!-- Region Header -->
            <div
                class="bg-gradient-to-r from-green-800 via-green-500 to-transparent text-white font-bold uppercase text-2xl px-6 py-3 rounded-t-lg w-full">
                {{ region.region }}
            </div>

            <!-- Subsections -->
            <div *ngFor="let section of region.subsections" class="mt-6">

                <!-- Section Title + Description -->
                <div class="flex items-center gap-3 mb-6">
                    <h3 class="text-green-700 font-bold text-xl whitespace-nowrap">
                        {{ section.title }}
                    </h3>
                    <p *ngIf="section.description" class="text-gray-700 text-lg">
                        {{ section.description }}
                    </p>
                </div>

                <!-- Cards Grid -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">

                    <div *ngFor="let train of section.services"
                        class="rounded-2xl shadow-md overflow-hidden text-center">

                        <div class="h-48 w-full overflow-hidden">
                            <img [src]="train.image" [alt]="train.title" class="w-full h-full object-cover" />
                        </div>

                        <div
                            class="bg-gradient-to-b from-white to-green-300 p-3 flex-1 flex flex-col items-center justify-start">
                            <h4 class="text-white font-bold text-lg bg-green-800 rounded-md py-2 px-3 inline-block">
                                {{ train.title }}
                            </h4>

                            <p class="text-gray-700 mt-2 font-medium min-h-[1.5rem]">
                                {{ train.country || '' }}
                            </p>
                        </div>

                    </div>
                </div>

            </div>

        </div>

        <div class="w-full bg-green-800 text-white py-10 rounded-lg">
            <div class="px-10">
                <h1 class="mb-5">Why Choose Optima Rail?</h1>
                <p class="mb-3"><span class="font-bold tracking-wide md:text-lg">Comprehensive Rail Solutions:
                    </span>From high-speed travel to scenic and luxury
                    journeys, we
                    offer a wide selection of rail experiences worldwide.</p>
                <p class="mb-3"><span class="font-bold tracking-wide md:text-lg">Expert Guidance & Support: </span>Our
                    team provides tailored recommendations and
                    seamless
                    booking assistance.</p>
                <p class="mb-3"><span class="font-bold tracking-wide md:text-lg">Flexible Travel Options: </span>Whether
                    it’s a single trip, an extended
                    adventure, or a luxury
                    escape, we cater to all travel styles.</p>
                <p class="mb-3"><span class="font-bold tracking-wide md:text-lg">Eco-Friendly Travel: </span>Rail
                    transport is one of the most sustainable ways to
                    explore the
                    world, reducing carbon footprints while maximizing comfort.</p>
            </div>
        </div>

        <div class="mt-10 text-center text-xl text-gray-600 max-w-xl mx-auto">
            Whether it’s a luxury train experience, a scenic rail journey, or flexible rail passes across continents,
            Optima Rail makes it seamless. Reach out to our experts and let your next journey begin long before you step
            on board.
            <div class="mt-3">
                For enquiries, mail us
                <a href="mailto:info@optimavibe.co.za" class="relative ml-1 font-medium text-green-800
                    transition-colors duration-300
                    hover:text-green-900
                    after:absolute after:left-0 after:-bottom-0.5
                    after:h-[2px] after:w-0
                    after:bg-green-800
                    after:transition-all after:duration-300
                    hover:after:w-full">
                    penny.mcaslin&#64;optimavibe.co.za
                </a>
            </div>
        </div>
    </section>
    }
</section>